import loadable from '@loadable/component';
import React from 'react';
import {StyleSheet, Text, TouchableOpacity, View} from 'react-native';
import {colorPalette, textStyles} from '../../../styles/Colors';
import BaseItem from './BaseItem';
const SVG = loadable(() => import('../../../imports/svg'));

export default function IconTextItem(props) {
  const {
    children,
    icon,
    title,
    subTitle,
    subIcon,
    onSubButtonPress,
    subButtonDisabled,
  } = props;
  return (
    <BaseItem
      {...props}
      children={
        <View style={styles.container}>
          {children}
          <View style={styles.titleWrapper}>
            <Text style={styles.title}>{title}</Text>
            <TouchableOpacity
              style={{
                flexDirection: 'row',
                justifyContent: 'flex-end',
                alignItems: 'center',
              }}
              onPress={onSubButtonPress}
              disabled={subButtonDisabled}>
              <Text
                style={styles.subTitle}
                numberOfLines={1}
                ellipsizeMode="tail">
                {subTitle}
              </Text>
              {!!subIcon && (
                <View style={styles.subIcon}>
                  <SVG name={subIcon} width={16} height={16} />
                </View>
              )}
            </TouchableOpacity>
          </View>
          {!!icon && (
            <View style={styles.icon}>
              <SVG name={icon} width={24} height={24} />
            </View>
          )}
        </View>
      }
    />
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
  },
  titleWrapper: {
    flex: 1,
    justifyContent: 'center',
  },
  title: {
    fontFamily: textStyles.bold,
    fontSize: 16,
    color: colorPalette.grey8,
    marginTop: 8,
  },
  subTitle: {
    fontFamily: textStyles.regular,
    fontSize: 12,
    color: colorPalette.grey6,
    marginBottom: 8,
  },
  icon: {
    marginRight: 16,
    marginLeft: 12,
    marginVertical: 20,
  },
  subIcon: {
    marginLeft: 4,
    marginBottom: 2,
  },
});
